import { Stack, Typography, useTheme } from "@mui/material";
import { SavingsSparkline } from "../settings/SavingsSparkline";
import { SavingsDataPoint, formatSavings } from "./useTenantSavings";

export const TenantSavingsDisplay = ({
  specificSavings,
  formattedMonth,
  dataPoints,
}: {
  specificSavings: number;
  formattedMonth: string;
  dataPoints: SavingsDataPoint[];
}) => {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <SavingsSparkline dataPoints={dataPoints} />
      <Stack alignItems="center" justifyContent="center" sx={{ pr: 1.5 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color:
              specificSavings >= 0
                ? theme.palette.success.main
                : theme.palette.error.main,
          }}
        >
          {formatSavings(specificSavings)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ({formattedMonth})
        </Typography>
      </Stack>
    </Stack>
  );
};
